export default __webpack_public_path__ + "static/media/WAS0333.34I-41685_-24966_0.b0ed184d.jpg";